import moment from "moment";

export default function Footer({ cssClass }) {
  return (
    <footer className={`d-flex pe-4 py-2 bg-light border-0 ${cssClass}`}>
      <span className="ms-auto">{moment().year()} © Avensys</span>
    </footer>
  );
}
